
window.addEventListener("load", function(){
	window.cookieconsent.initialise({
		"palette": null, // Styles in _cookieconsent.scss
		// "static": true, // use in conjunction with postion:banner reveal banner behind page
		// "position": "bottom-left", // Floating left
		// "position": "bottom-right", // Floating right
		// "position": "top", // Banner top
		// "position": "banner", // Banner top
		// leave out position entirely for banner bottom
		"content": {
			"message": "Diese Webseite verwendet Cookies zur Optimierung der Webseitennutzung. Einzelheiten über die von uns eingesetzten Cookies finden Sie in unseren",
			"dismiss": "Schließen",
			"link": "Datenschutzbestimmungen.",
			"href": "https://www.lebenshilfe.de/datenschutz"
		}
	})
});